import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";
import { cn, getTrueDate } from "@/lib/utils";
import { format } from "date-fns";
import { useAtomValue } from "jotai";
import { motion } from "motion/react";

type DateTabProps = {
  date: string,
  selected: boolean,
  setSelected: (id: string) => void
}

const DateTab = ({date, selected, setSelected}: DateTabProps) => {

  const theme = useAtomValue(themeAtom)

  return (
  <div
      className={cn("flex flex-col items-center cursor-pointer justify-center border border-black min-w-[4.5rem] aspect-square rounded-md relative",
      selected ? "text-white" : "text-gray-600")}
      onClick={() => setSelected(date)}
    >
      <p className="font-poppins z-10 text-sm">{format(new Date(date), "MMM")}</p>
      <span className="relative z-10 font-header font-medium text-3xl">{getTrueDate(date, "d")}</span>
      {selected && (
        <motion.span
          layoutId="pill-tab"
          transition={{ type: "spring", duration: 0.5 }}
          style={{ backgroundColor: theme.primary }}
          className="absolute inset-0 z-0 rounded-md"
        ></motion.span>
      )}
    </div>
  )
}

export default DateTab;
